var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 330,
    viewBox: "0 0 60 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-247.99 328.282C-229.075 304.894 -224.956 301.188 -205.547 286.372C-200.793 282.741 -191.549 277.029 -180.131 271.574C-176.714 269.94 -173.326 268.457 -169.985 267.098C-146.078 257.405 -119.295 256.036 -92.8442 258.288C-25.3551 264.038 35.5568 227.506 53.3141 172.195C71.0999 116.789 41.8398 55.2628 -3.82049 25.2409C-9.76173 21.3349 -37.7976 4.10483 -68.5572 1.55786C-165.677 -6.5107 -204.485 87.5655 -233.868 230.709C-234.437 233.493 -236.611 246.751 -237 249.564L-248 328.292L-247.99 328.282Z",
    stroke: "#A8AEBE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector16);
export default __webpack_public_path__ + "static/media/vector1-6.cd0483b45ba62835befae5bd687ba6a9.svg";
export { ForwardRef as ReactComponent };